import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";

type CleanChoice = "nothing" | "delete_future";

interface CleanSessionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (choice: CleanChoice) => Promise<void>;
  isDoingIt?: boolean;
}

export const CleanSessionsModal: React.FC<CleanSessionsModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isDoingIt = false,
}) => {
  const [choice, setChoice] = useState<CleanChoice>("nothing");

  const handleDoIt = async () => {
    await onConfirm(choice);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Clean up sessions</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          WARNING! This will do a bulk delete of sessions! BE CAREFUL!
        </p>
        <RadioGroup
          value={choice}
          onValueChange={(v) => setChoice(v as CleanChoice)}
          className="flex flex-col gap-2"
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="nothing" id="clean-nothing" />
            <Label htmlFor="clean-nothing">Just kidding, do nothing</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="delete_future" id="clean-delete-future" />
            <Label htmlFor="clean-delete-future">Delete all future sessions (except placeholders)!</Label>
          </div>
        </RadioGroup>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isDoingIt}>
            Cancel
          </Button>
          <Button onClick={handleDoIt} disabled={isDoingIt}>
            DO IT!
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
